import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import useMdUpScreen from '../hooks/useMdUpScreen';
import Title from './Title';
import useFileZone from '../hooks/useFileZone';
import useIsMobileByNavigator from '../hooks/useIsMobileByNavigator';
import { useDispatch } from 'react-redux';
import { setCameraMode } from '../store/camera';
import useIsMobile from '../hooks/useIsMobile';
import { checkImageSize } from '../helper';
import BasicError from './BasicError';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

function FileZoneContainer({ children, sx, fileZone, control }) {
  const {
	  ref,
	  handleChange,
	  onDrop,
	  onDragOver,
	  onDragLeave,
	  onDropZoneClick
  } = fileZone;
  return (
	<Box sx={sx} onClick={onDropZoneClick} onDrop={onDrop} onDragLeave={onDragLeave} onDragOver={onDragOver}>
		<input
			type="file"
			name={control.id}
			id={control.id}
			onChange={handleChange}
			accept="image/png, image/jpeg, image/jpg"
			ref={ref}
			style={{ display: 'none' }}
		/>
		{children}
	</Box>
  );
}

function CamaraContainer({ children, sx }) {
	const dispatch = useDispatch();
  const onCameraClick = () => {
	  // ref.current.click();
	  dispatch(setCameraMode(true));
  };
  
  
  return (
	  <Box sx={sx} onClick={onCameraClick}>
		{children}
	  </Box>
  );
}

function PhotoContainer({ children, fromMobilePhone, control, fileZone, sx }) {
  const userUsesCamara = useSelector((state)=>state.camera.userUsesCamara); 
  //Usuario ocupa camara, se puede agregar un botón switch que cambie a selector de archivo en sistema y camara, pero se omitió
  const renderCamara = fromMobilePhone && userUsesCamara;
  return renderCamara ? (
  	<CamaraContainer sx={sx}>
		{children}
	</CamaraContainer>) : (
	<FileZoneContainer sx={sx} fileZone={fileZone} control={control} >
		{children}
	</FileZoneContainer>
  );
}


function PhotoInput({ saveMethod, control, setImgSize, showValidation }) {
  	const mdUpScreen = useMdUpScreen();
	const mainState = useState({ hover: false, error: false, errorText: '' });
	const [state, setState] = mainState;
	const fileZone = useFileZone(mainState,saveMethod);
	const { hover, error, errorText } = state;
	const { data, text, size, source, id, validation } = control;
	const { width, height } = size;
	const [preview, setPreview] = useState(false);
    useEffect(() => {
		async function getSize() {
			const size = await checkImageSize(data,'url');
			setImgSize(id, size);
		  }
        if (data === '') {
            setPreview(false);
            return;
        }
		let objectUrl = '';
		if(source === 'user') {
			objectUrl = URL.createObjectURL(data);
        	setPreview(objectUrl);
		}else{
			setPreview(data);
			getSize();			
		}
        // liberar memoria cuando componente sea desmontado
        return () => { if(source === 'user') URL.revokeObjectURL(objectUrl) }
    }, [data]);
	
	const styles = useThemeCustomStyles();
	const topBorder = styles.PhotoInput.FileBoxTopBorder;
	const sxHover = hover ? styles.PhotoInput.FileHoverFunction : {};
	const sxContainer = {
		...styles.PhotoInput.FileBox,
		...topBorder,
		...sxHover,
	};

	const fromMobilePhone = useIsMobileByNavigator();
	const verticalScreen = useIsMobile();

	const containerHeight = styles.PhotoInput.ContainerHeight(width, height, fromMobilePhone);
	const ImageStyle = styles.PhotoInput.Image(width, height, fromMobilePhone, verticalScreen);
	return (
		<Stack>
			<Box sx={{ height: containerHeight, ...styles.PhotoInput.FileBoxContainer(mdUpScreen),  ...topBorder }}>
				<PhotoContainer fromMobilePhone={fromMobilePhone} control={control} fileZone={fileZone} sx={sxContainer} >
					{!preview && (<Stack>
						{data === '' && (
							<Title>
								{text}
							</Title>
						)}
						{error && (<>
							<br />
							<BasicError error={errorText} />
						</>)}
					</Stack>)}
					{preview && (
						<Box component="img" 
						src={preview} 
						sx={ImageStyle} />
					)}
					
				</PhotoContainer>
			</Box>
			{showValidation && !validation.valid && (<BasicError error={validation.text} />)}
		</Stack>
	);
}

export default PhotoInput;